var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTickActiveIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 1C1.887 1 1 1.895 1 3V9C1 10.113 1.895 11 3 11H9C10.113 11 11 10.105 11 9V3C11 1.887 10.105 1 9 1H3Z",
    fill: "#CFCFCF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.40245 8.20245C5.32349 8.20291 5.24521 8.18778 5.17211 8.15792C5.09901 8.12806 5.03252 8.08406 4.97645 8.02845L3.17646 6.22845C3.12051 6.17251 3.07614 6.1061 3.04586 6.033C3.01558 5.95991 3 5.88157 3 5.80245C3 5.64267 3.06347 5.48944 3.17646 5.37645C3.28944 5.26347 3.44267 5.2 3.60246 5.2C3.76224 5.2 3.91547 5.26347 4.02846 5.37645L5.40245 6.75645L7.97646 4.17645C8.08944 4.06347 8.24267 4 8.40245 4C8.56224 4 8.71547 4.06347 8.82845 4.17645C8.94144 4.28944 9.00491 4.44267 9.00491 4.60245C9.00491 4.76224 8.94144 4.91547 8.82845 5.02845L5.82845 8.02845C5.77239 8.08406 5.7059 8.12806 5.6328 8.15792C5.5597 8.18778 5.48142 8.20291 5.40245 8.20245Z",
    fill: "#24272A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickActiveIcon);
export default __webpack_public_path__ + "static/media/tick-active-icon.01e409e85011cd5dacf3b41a6e19f9a7.svg";
export { ForwardRef as ReactComponent };